import { useAppContext } from '../context/AppContext';
import assetPath from '../utils/assetPath';

const Footer = () => {
  const { language } = useAppContext();

  return (
    <footer className="site-footer">
      <p>© {new Date().getFullYear()} SΛLTY Airsoft · Built for the field</p>
      <div className="footer-links">
        <a className="footer-link" href="https://www.instagram.com/salty.airsoft/" target="_blank" rel="noreferrer">
          <span className="insta-icon">
            <img src={assetPath('/assets/logo-instagram.webp')} alt="Instagram logo" />
          </span>
          <span>@salty.airsoft</span>
        </a>
        <a className="footer-link" href="https://discord.gg/ncMBPzqVza" target="_blank" rel="noreferrer">
          <span className="insta-icon">
            <img src={assetPath('/assets/logo-discord.png')} alt="Discord logo" />
          </span>
          <span>{language === 'fr' ? 'Rejoindre Discord' : 'Join Discord'}</span>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
